import { GspWidgetManifest } from './gsp-widget-manifest';

export class GspWidgetManager {

    getType(name) {
        return GspWidgetManifest.prototype.getWidgetType(name);
    }

    getProviders() {
        return GspWidgetManifest.prototype.getProviders();
    }
}